module.exports = __webpack_public_path__ + "img/pay_fail.51bc81c4.png";